import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {Injectable} from '@angular/core';

@Injectable()
export class MediaService {
  private resourceUrl = environment.apiUrl + 'mediaDocument';

  constructor(private http: HttpClient) { }

  getAllMedia(): Observable<any[]> {
    return this.http.get<any[]>(this.resourceUrl + '/list');
  }
  getAllMediaByType(type: any): Observable<any[]> {
    return this.http.get<any[]>(this.resourceUrl + '/list/' + type);
  }
  getMedia(id: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/' + id);
  }
  create(request): Observable<any[]> {
    return this.http.post<any[]>( this.resourceUrl , request);
  }
  save(request: any): Observable<any[]> {
    return this.http.post<any[]>( this.resourceUrl, request);
  }
  delMedia(id: number): Observable<any> {
    return this.http.delete<any>(this.resourceUrl + '/' + id);
  }
  loadDocument(file: File, fileType: number, idMedia: number): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('type', fileType + '');
    return this.http.post<any[]>(this.resourceUrl + '/document/' + idMedia, formData, {observe: 'response'});
  }

  loadDocumentNew(file: File, fileType: number): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('type', fileType + '');
    return this.http.post<any[]>(this.resourceUrl + '/document/create/M', formData, {observe: 'response'});
  }
  loadDocumentNewIcon(file: File, fileType: number): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('type', fileType + '');
    return this.http.post<any[]>(this.resourceUrl + '/document/create/I', formData, {observe: 'response'});
  }
}



// WEBPACK FOOTER //
// ./src/app/media/media.service.ts